export const FETCH_THEMES = '@@themes/FETCH_THEMES';
export const FETCH_THEMES_SUCCESS = '@@themes/FETCH_THEMES_SUCCESS';
export const FETCH_THEMES_ERROR = '@@themes/FETCH_THEMES_ERROR';
export const FETCH_THEME = '@@themes/FETCH_THEME';
export const FETCH_THEME_SUCCESS = '@@themes/FETCH_THEME_SUCCESS';
export const FETCH_THEME_ERROR = '@@themes/FETCH_THEME_ERROR';
